import axios from 'axios';
import { API } from '../App';

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

export function isPushSupported() {
  return typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return null;
  try {
    return await navigator.serviceWorker.register('/sw.js');
  } catch (e) {
    console.warn('SW register failed', e);
    return null;
  }
}

export async function subscribeToPush() {
  if (!isPushSupported() || !VAPID_PUBLIC_KEY) return { ok: false, reason: 'unsupported' };
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return { ok: false, reason: 'denied' };

  const reg = await navigator.serviceWorker.ready;
  let subscription = await reg.pushManager.getSubscription();
  if (!subscription) {
    subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });
  }
  const payload = subscription.toJSON();
  const token = localStorage.getItem('arthik_token');
  if (!token) return { ok: false, reason: 'no-auth' };
  await axios.post(`${API}/push/subscribe`, {
    endpoint: payload.endpoint,
    keys: payload.keys,
  }, { headers: { Authorization: `Bearer ${token}` } });
  return { ok: true, subscription: payload };
}

export async function unsubscribeFromPush() {
  if (!isPushSupported()) return { ok: false };
  const reg = await navigator.serviceWorker.ready;
  const subscription = await reg.pushManager.getSubscription();
  if (!subscription) return { ok: true };
  const payload = subscription.toJSON();
  const token = localStorage.getItem('arthik_token');
  if (token) {
    try {
      await axios.post(`${API}/push/unsubscribe`, {
        endpoint: payload.endpoint,
        keys: payload.keys,
      }, { headers: { Authorization: `Bearer ${token}` } });
    } catch (e) { /* ignore */ }
  }
  await subscription.unsubscribe();
  return { ok: true };
}

export async function getPushStatus() {
  if (!isPushSupported()) return 'unsupported';
  if (Notification.permission === 'denied') return 'denied';
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return 'not-registered';
  const sub = await reg.pushManager.getSubscription();
  if (sub) return 'subscribed';
  if (Notification.permission === 'granted') return 'granted-not-subscribed';
  return 'default';
}
